<mat-sidenav-container class="theme-smaller-form-fields theme-smaller-buttons">
	<mat-sidenav #sidenav mode="push" position="end" class="p-3">
		<p class="fs-5 text-center fw-bold" [tabindex]="0">Pojazdy</p>
		<form class="d-flex flex-column gap-2">
			<mat-form-field subscriptSizing="dynamic" appearance="outline" class="w-100 text-small">
				<mat-label>Wyszukaj pojazd</mat-label>
				<input matInput [autofocus]="false" [matAutocomplete]="auto" [formControl]="searchControl" />
				<mat-autocomplete #auto="matAutocomplete" [displayWith]="displayFn">
					@for (vehicle of filteredVehicles$ | async; track vehicle.id) {
						<mat-option [value]="vehicle">{{ vehicle.name }}</mat-option>
					}
				</mat-autocomplete>
			</mat-form-field>
			<button type="button" mat-raised-button color="primary" (click)="selectVehicle()">Wybierz</button>
		</form>
		<div class="mt-4 d-flex flex-column gap-3">
			<p class="fs-5 text-center fw-bold">Wybrane pojazdy</p>
			<app-vehicles-table
				[vehicles]="store.vehicles()"
				(vehicleUnselected)="unSelectVehicle($event)"
				(vehicleVisibilityToggled)="store.toggleVehicleRouteVisibility($event)"
				(vehicleCrewChanged)="calculateVehicleFreeSeats($event)"
				(vehicleUsed)="useVehicle($event)"
			></app-vehicles-table>
			@if (store.shouldShowToggleAllVehiclesRoutes()) {
				<button
					mat-raised-button
					color="primary"
					class="align-self-end"
					(click)="store.setAllVehiclesRoutesVisible()"
				>
					Pokaż trasy dla wszystkich pojazdów
				</button>
			}
		</div>
	</mat-sidenav>
	<mat-sidenav-content>
		<ng-content></ng-content>
	</mat-sidenav-content>
</mat-sidenav-container>
